import { WaterCurrent } from '../services/postService';
import { DepthUnit, TemperatureUnit, celsiusToFahrenheit, feetToMeters, fahrenheitToCelsius, metersToFeet } from './unitConversions';

export const CURRENT_OPTIONS: { value: WaterCurrent; label: string }[] = [
  { value: 'None', label: 'None' },
  { value: 'Light', label: 'Light' },
  { value: 'Moderate', label: 'Moderate' },
  { value: 'Strong', label: 'Strong' },
];

export const RATING_LABELS: Record<number, string> = { 1: 'Poor', 2: 'Fair', 3: 'Good', 4: 'Great', 5: 'Excellent' };

/** Visibility is stored in meters; shown in the viewer's depth unit, whole numbers (nobody reports 12.4 m of viz). */
export const formatVisibility = (meters: number, unit: DepthUnit): string =>
  unit === 'feet' ? `${Math.round(metersToFeet(meters))} ft` : `${Math.round(meters)} m`;

export const formatWaterTemp = (celsius: number, unit: TemperatureUnit): string =>
  unit === 'fahrenheit' ? `${Math.round(celsiusToFahrenheit(celsius))}°F` : `${Math.round(celsius)}°C`;

/** What a diver typed (in their own unit) back to the metric value the API stores. */
export const visibilityToMeters = (value: number, unit: DepthUnit): number => (unit === 'feet' ? feetToMeters(value) : value);
export const tempToCelsius = (value: number, unit: TemperatureUnit): number => (unit === 'fahrenheit' ? fahrenheitToCelsius(value) : value);

/** "today", "2 days ago" — for how fresh a summary is. */
export const timeAgo = (iso: string): string => {
  const hours = (Date.now() - new Date(iso).getTime()) / 36e5;
  if (hours < 1) return 'less than an hour ago';
  if (hours < 24) return `${Math.floor(hours)} hour${Math.floor(hours) === 1 ? '' : 's'} ago`;
  const days = Math.floor(hours / 24);
  return `${days} day${days === 1 ? '' : 's'} ago`;
};
